import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-673a189a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-left" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "mb-4 p-4 rounded-3 container-lg container-fluid" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "First Name")
], -1))
const _hoisted_11 = { class: "border rounded-3 p-2" }
const _hoisted_12 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Middle Name")
], -1))
const _hoisted_14 = { class: "border rounded-3 p-2" }
const _hoisted_15 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Last Name")
], -1))
const _hoisted_17 = { class: "border rounded-3 p-2" }
const _hoisted_18 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "User Name")
], -1))
const _hoisted_20 = { class: "border rounded-3 p-2" }
const _hoisted_21 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1))
const _hoisted_23 = { class: "border rounded-3 p-2" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1))
const _hoisted_28 = { class: "border rounded-3 p-2" }
const _hoisted_29 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Landline")
], -1))
const _hoisted_31 = { class: "border rounded-3 p-2" }
const _hoisted_32 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nationality")
], -1))
const _hoisted_34 = { class: "border rounded-3 p-2" }
const _hoisted_35 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Country of Residence")
], -1))
const _hoisted_37 = { class: "border rounded-3 p-2" }
const _hoisted_38 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1))
const _hoisted_40 = { class: "border rounded-3 p-2" }
const _hoisted_41 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Description")
], -1))
const _hoisted_43 = { class: "border rounded-3 p-2" }
const _hoisted_44 = { class: "col-12 mb-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Passport Number")
], -1))
const _hoisted_46 = { class: "border rounded-3 p-2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-2" }, "Alternate Contact", -1))
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "First Name")
], -1))
const _hoisted_51 = { class: "border rounded-3 p-2" }
const _hoisted_52 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Middle Name")
], -1))
const _hoisted_54 = { class: "border rounded-3 p-2" }
const _hoisted_55 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Last Name")
], -1))
const _hoisted_57 = { class: "border rounded-3 p-2" }
const _hoisted_58 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1))
const _hoisted_60 = { class: "border rounded-3 p-2" }
const _hoisted_61 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1))
const _hoisted_63 = { class: "border rounded-3 p-2" }
const _hoisted_64 = ["href"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "confirmation-content" }
const _hoisted_67 = {
  key: 0,
  class: "row"
}
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "placeholder" }, null, -1))
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center py-5" }, "No partnership declaration found!...", -1))
const _hoisted_73 = [
  _hoisted_72
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.profileData?.profile_picture?.length > 1)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.profileData?.profile_picture,
              alt: _ctx.profileData?.first_name,
              width: "75",
              height: "75",
              class: "rounded-circle"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "my-3 p-button-raised p-button-text"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Back")
          ]),
          _: 1
        })
      ]),
      _hoisted_6,
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.profileData?.first_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.profileData?.middle_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.profileData?.last_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("h6", _hoisted_20, _toDisplayString(_ctx.profileData?.username || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("h6", _hoisted_23, [
              (_ctx.profileData?.email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `mailto:${_ctx.profileData?.email}?subject=BHMIS`
                  }, _toDisplayString(_ctx.profileData?.email), 9, _hoisted_24))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString("-")))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("h6", _hoisted_28, _toDisplayString(_ctx.profileData?.mobile || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("h6", _hoisted_31, _toDisplayString(_ctx.profileData?.landline || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("h6", _hoisted_34, _toDisplayString(_ctx.profileData?.nationality || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("h6", _hoisted_37, _toDisplayString(_ctx.profileData?.country_of_residence || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("h6", _hoisted_40, _toDisplayString(_ctx.profileData?.gender || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("h6", _hoisted_43, _toDisplayString(_ctx.profileData?.short_description || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("h6", _hoisted_46, _toDisplayString(_ctx.profileData?.passport_number || "-"), 1)
          ])
        ]),
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("h6", _hoisted_51, _toDisplayString(_ctx.profileData?.details?.alternate_contact_first_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("h6", _hoisted_54, _toDisplayString(_ctx.profileData?.details?.alternate_contact_middle_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("h6", _hoisted_57, _toDisplayString(_ctx.profileData?.details?.alternate_contact_last_name || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("h6", _hoisted_60, _toDisplayString(_ctx.profileData?.details?.alternate_contact_mobile || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("h6", _hoisted_63, [
              (_ctx.profileData?.details?.alternate_contact_email)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `mailto:${_ctx.profileData?.details?.alternate_contact_email}?subject=BHMIS`
                  }, _toDisplayString(_ctx.profileData?.details?.alternate_contact_email), 9, _hoisted_64))
                : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString("-")))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: 'Partnership Declarations',
      visible: _ctx.partnershipsModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.partnershipsModal) = $event)),
      style: { width: '30rem' },
      modal: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          (_ctx.getPartnershipDeclarations?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPartnershipDeclarations, (el, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createElementVNode("pre", null, _toDisplayString(el), 1),
                      _createElementVNode("p", _hoisted_70, _toDisplayString(el.status), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.getPartnershipDeclarations?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}